import fleetback from '../assets/Icons/fleetback.svg';
import {ContextDTO} from "../models/dto/context-dto";

const getLogo = (context: Partial<ContextDTO>) => {
    return context.logoPath ?? fleetback;
}

export default getLogo;
